<section id="retirement-plans">
  <div class="container">
      <div class="row">
          <div class="col-12">
              <h1>Secure 2.0 Webinar</h1>
          </div>
      </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
        <div class="col-md-12"><div class="text-center mx-auto">
            <h3>Secure 2.0 Webinar Video and Slides</h3> 
            <p>Annie Messer from the Pension Resource Institute and Steve Sokolic of Retirement Law Group explain how the new Secure 2.0 act will impact Church retirement plans.</p>
            <img src="https://img.youtube.com/vi/iTAPiG1ZeT4/hqdefault.jpg" alt="Download Secure 2.0 Webinar Slides" class="mb-3" width="480" height="360"><div class="clearfix"></div><a href="https://www.ifa.com/pdfs/ifc-webinar-slides-secure-2-0.pdf" target="_blank" class="btn btn-primary mt-3 mb-3">Download Webinar Slides</a><br />
            <a href="/videos/secure-2-how-does-it-impact-your-church-plan" class="btn btn-primary mt-3 mb-5">Watch the Video</a>
      </div>
      </div>
    </div>
    </div>
</section>